import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../../models/hooks/appStateHooks';
import { LevStandardQueryMeta } from '../../../web/ReactQueryProvider';
import { timeEntryKeys } from './keys';
import { ITimeEntryMissing } from './types';

export function useTimeEntryMissingQuery({
	enabled = true,
	managerUserId,
}: {
	enabled?: boolean;
	managerUserId?: string;
} = {}) {
	const userSession = useUserSession();
	return useQuery({
		queryKey: timeEntryKeys.missing(managerUserId),
		queryFn: () =>
			userSession.webServiceHelper.callAsync<ITimeEntryMissing>(
				managerUserId ? `TimeEntry/missing?${new URLSearchParams({ managerUserId })}` : 'TimeEntry/missing',
				'GET'
			),
		enabled,
		// The response also carries the manager options, which must stay put while a new manager pick loads; callers
		// should treat isPlaceholderData as loading for the rows.
		placeholderData: keepPreviousData,
		staleTime: 60_000,
		meta: {
			errorLogging: { action: 'TimeEntryMissingQuery-Error', category: 'TimeEntry' },
		} satisfies LevStandardQueryMeta,
	});
}
